// @flow

import React, { type Node } from 'react';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { getMoneyFormat } from '@tectonics/look-and-feel/shopify/commons/money-format';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { useCurrentReceipt } from '@tectonics/prs/receipts';
import { PaymentInfo } from '../../../organisms/payment-info';
import PagofacilTaxesInfo from './pagofacil-taxes-info';

type Props = {|
  label: string,
  location ?: string,
  redesign ?: boolean,
  subLabel ?: string,
|};

export default function DisplayTotalAmountWithTaxesTip({ label, location = null, redesign = null, subLabel = null }: Props): Node {
  const incomingPayment = useIncomingPayment();
  const receipt = useCurrentReceipt();
  const decimalFormat = getMoneyFormat(getCountry(incomingPayment));
  const formatAmount = amountToCurrencyString(decimalFormat);
  return (
    <PaymentInfo label={label} location={location} redesign={redesign} subLabel={subLabel}>
      {formatAmount(getReceiptAmountLocalTotal(receipt))}&nbsp;<PagofacilTaxesInfo />
    </PaymentInfo>
  );
}
